'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createThumbnail;

var _changeImageSize = require('./changeImageSize');

var _changeImageSize2 = _interopRequireDefault(_changeImageSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * generate preview image
 * modify image quality
 *
 * @param file
 * @param quality
 * @param fileType
 * @param maxWidth
 * @param maxHeight
 * @param callback
 */
function createThumbnail(image, callback) {
  var file = image.file,
      quality = image.quality,
      fileType = image.fileType,
      maxWidth = image.maxWidth,
      maxHeight = image.maxHeight;

  var img = document.createElement('img');

  window.URL = window.URL || window.webkitURL;
  img.src = window.URL.createObjectURL(file);

  img.onload = function () {
    var imgUrl = void 0;

    if (quality || maxWidth || maxHeight) {
      imgUrl = (0, _changeImageSize2.default)({ img: img, quality: quality, fileType: fileType, maxWidth: maxWidth, maxHeight: maxHeight });
    } else {
      imgUrl = img.src;
    }

    callback(imgUrl);
  };
}

// FileReader
// export default function createThumbnail({ file, quality, fileType, maxWidth, maxHeight }, callback) {
//   const img = document.createElement('img');
//   const reader = new FileReader();

//   reader.onload = (e) => {
//     img.src = e.target.result;

//     callback(img.src);
//   };

//   reader.readAsDataURL(file);
// }